module.exports = __webpack_public_path__ + "static/media/linkedin.64325774.PNG";